



































































































































































import { defineComponent, ref, watch } from '@vue/composition-api';

import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonPartOfSidebar from '@/components/CommonPartOfSidebar.vue';

const AppFast = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonPartOfSidebar,
  },
  setup() {
    const { me, hasPermission } = useAuth();

    const currentExpand = ref('');

    return {
      me,
      hasPermission,
      currentExpand,
    };
  },
});

export default AppFast;
